<div class="flex-grow-1 keyboard d-flex gap-8">
  <div class="keyboard__left flex-grow-1">
    <div class="d-grid gap-8 keyboard__left__top">
      @for (val of [7, 8, 9, 4, 5, 6, 1, 2, 3]; track val) {
        <button class="button button--quick-action" (click)="keyClick.emit(val.toString())" type="button">
          <span class="t1">{{ val }}</span>
        </button>
      }
    </div>
    <div class="d-grid m-t-8 gap-8 keyboard__left__bottom">
      <button class="button button--quick-action" (click)="keyClick.emit('0')" type="button">
        <span class="t1">0</span>
      </button>

      @if (!isSimple) {
        <button class="button button--quick-action" (click)="keyClick.emit('00')" type="button">
          <span class="t1">00</span>
        </button>
      } @else {
        <button class="button button--quick-action" (click)="deleteBack.emit()" type="button">
          <i class="ri-delete-back-2-line"></i>
        </button>
      }
    </div>
  </div>
  @if (!isSimple) {
    <div class="keyboard__right d-flex flex-direction-column gap-8">
      <button class="button button--quick-action" (click)="deleteBack.emit()" type="button">
        <i class="ri-delete-back-2-line"></i>
      </button>
      <button
        class="button button--quick-action button--quick-action--strong text-uppercase"
        (click)="clear.emit()"
        type="button"
      >
        {{ 'Reset'| trans:'shared/keyboard/reset.Button' }}
      </button>
      <button class="button button--quick-action h-0 flex-grow-1"></button>
    </div>
  }
</div>
